// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
Vue.use(Vuetify, {
  theme: {
    primary: "#cc392e",
    secondary: colors.orange.accent1
  },
  options: {
    customProperties: true
  }
})

import router from './router'
import store from './store'
import Root from './Root'

import Checkbox from '@/components/Checkbox' 
Vue.component('checkbox', Checkbox)

Vue.config.productionTip = false

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  store,
  router,
  components: { Root },
  render(h) { return h('Root') }
})



// WEBPACK FOOTER //
// ./src/main.js